'use client';

import { useTranslation } from 'react-i18next';

import { CardExpiryField } from '@sola/ark-core/molecules/credit-card-fields/credit-card-expiry.js';
import { CreditCardFields } from '@sola/ark-core/molecules/credit-card-fields/credit-card-fields.js';
import { CardNameField } from '@sola/ark-core/molecules/credit-card-fields/credit-card-name.js';
import { InputField } from '@sola/ark-core/molecules/input-field/input-field.js';
import { SupporterCCFieldsEnum } from '@sola/schema/dotcom/supporters/paymentMethods.js';
import { GraphQLSupporterPaymentMethod } from '@sola/schema/dotcom/supporters/schema.generated.js';
import { getShortExpiryDate } from '@sola/shared-utils/credit-cards.js';

export interface UpdateCCFields {
  paymentMethod: GraphQLSupporterPaymentMethod;
}

export const UpdateCCFields: React.FC<UpdateCCFields> = ({ paymentMethod }) => {
  const { t } = useTranslation('my');

  return (
    <CreditCardFields>
      <CardNameField
        name={SupporterCCFieldsEnum.nameOnCard}
        value={paymentMethod.creditCard?.cardholderName}
        required
      />

      <CardExpiryField
        name={SupporterCCFieldsEnum.expirationDate}
        value={getShortExpiryDate(
          paymentMethod.creditCard?.expirationDate ?? '',
        )}
        required
      />

      <InputField
        name={SupporterCCFieldsEnum.nickname}
        label={t('updatePaymentMethod.form.fields.cardNickname')}
        value={paymentMethod.accountNickname}
        hint={t('updatePaymentMethod.form.fields.optional')}
      />
    </CreditCardFields>
  );
};
